<template>
  <v-container class="py-0 px-0" fluid tag="section">
    <base-material-table flat :item="item" :excel='excel' @on-add='addModal = { show: true, type: 2 }' ref="table">
      <template v-slot:condition>
        <v-col cols="12" sm='2' class='condition-col'>
          <v-select
            hide-details
            outlined dense
            :items="timeRanges"
            v-model="item.params.annualTimeType"
            item-text="label"
            item-value="value"
            label="到期时间"
            clearable
            clear-icon="mdi-close-circle-outline"
            @change="loadData"
            >
          </v-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
          <v-select
            hide-details
            outlined dense
            label="年份选择"
            :items='yearItems'
            @change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.costYear'>
          </v-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
          <base-marerial-user-select @on-change="loadData" label='用户选择(负责人)' hide-details outlined dense v-model="item.params.userIds" mid :menu='$constants.SysMenu.PARTENT_LIST_M_ID'></base-marerial-user-select>
        </v-col>
      </template>
    </base-material-table>

    <v-dialog max-width="450" v-model="annualModal.show">
       <template v-slot:default="dialog">
         <v-card class="pb-5">
           <v-card-title class="text-h6">
             续费提示（{{ form.year }}年）
           </v-card-title>
           <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field label="年费金额" hide-details="auto" outlined :rules="number" v-model="form.annualFee"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field label="其他费用" hide-details="auto" outlined :rules="number" v-model="form.otherFee"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <file-upload
                    label="收据上传(命名：专利号_***年费收据.pdf)"
                    outlined
                    small-chips
                    multiple
                    prepend-icon=''
                    accept=".pdf"
                    :bucket='bucket'
                    @on-files='onFileName'
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea rows='3' label="备注信息" outlined v-model="form.remark"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
           </v-card-text>
           <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn class="text--disabled" text @click="dialog.value = false">
               取消
             </v-btn>
             <v-btn color="primary" :loading="loading" @click="cost">
               提交
             </v-btn>
           </v-card-actions>
         </v-card>
       </template>
    </v-dialog>
    <overdue-view :item='overdueModal'></overdue-view>
    <add-out :item='addModal' @on-load-data='loadData'></add-out>
  </v-container>
</template>

<script>
  import FileUpload from '@/components/oss/Index.vue'
  import { save } from '@/api/patent/cost.js'
  import { getNextMonth, selectBeforeYear } from '@/utils/tool.js'
  import AddOut from '@/views/pages/pc/patent/info/components/AddOut.vue'
  import OverdueView from './Overdue.vue'

  export default {
    name: 'PatentAnnualCost',
    components: {
      OverdueView,
      AddOut,
      FileUpload
    },
    data() {
      return {
        bucket: 'yd-patent',
        timeRanges: [
          { label: '已超时', value: '-1' },
          { label: '30天内', value: '0' },
          { label: '15天内', value: '1' },
          { label: '7天内', value: '2' }
        ],
        form: {
          annualFee: '',
          patentId: '',
          otherPrice: '',
          remark: '',
          year: Number(this.$moment().format('YYYY'))
        },
        number: [
          value => !!value || '此项为必填项!',
          value => /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(value) || '必须输入数字',
        ],
        loading: false,
        yearItems: selectBeforeYear(1),
        addModal: { show: false, data: {} },
        detailModal: { show: false, data: {} },
        annualModal: { show: false, data: {} },
        overdueModal: { show: false, data: {} },
        item: {
          mobile: true,
          path: 'patent/info/nextCost',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has('patent-cost-add') },
            { event: 'download', show: this.$_has('patent-info-down') }
          ],
          params: {
            listType: 3,
            statusSet: [30, 35, 36],
            annualTimeType: '',
            costYear: Number(this.$moment().format('YYYY'))
          },
          sort: {
            orderByField: "from_unixtime(patent.accept_time,'%m-%d')",
            asc: true
          },
          headers: [
            {
              text: '企业名称',
              align: 'center',
              divider: true,
              value: 'customerName',
              sortable: false,
              copy: true,
              width: 200,
              mobile: true,
              search: { type: 'input', seckey: 'customerName', mobile: true }
            },
            {
              text: '专利名称',
              align: 'center',
              divider: true,
              value: 'name',
              sortable: false,
              copy: true,
              width: 210,
              mobile: true,
              search: { type: 'input', mobile: true },
            },
            {
              text: '专利编号',
              align: 'center',
              divider: true,
              value: 'patentCode',
              sortable: false,
              copy: true,
              width: 170,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
              {
                text: '申请时间',
                align: 'center',
                divider: true,
                value: 'acceptTime',
                sortable: true,
                width: 130,
                mobile: true,
                formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
              },
              {
                text: '授权时间',
                align: 'center',
                value: 'authTime',
                divider: true,
                sortable: true,
                width: 130,
                mobile: true,
                formatter: (val) => (val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--')
              },
              {
                text: '预计待缴金额',
                align: 'center',
                divider: true,
                value: 'annualFee',
                sortable: false,
                mobile: true,
                width: 120
              },
              {
                text: '缴费年限',
                align: 'center',
                divider: true,
                value: 'yearCostNumber',
                sortable: false,
                width: 90,
                mobile: true,
                formatter: (val) => `第${val + 1}年`,
              },
              {
                text: '缴费截止时间',
                align: 'center',
                divider: true,
                value: 'acceptTime',
                sortable: false,
                width: 150,
                mobile: true,
                span: {
                  color: (val) => this.costColor(this.costDay(val)),
                  formatter: (val) => this.$moment(this.costDay(val)).format('YYYY-MM-DD')
                }
              },
              {
                text: '专利类型',
                align: 'center',
                divider: true,
                value: 'patentType',
                sortable: false,
                mobile: true,
                width: 170,
                chip: {
                  color: (val) => (val === 1 ? 'success' : val === 2 ? 'cyan' : 'blue'),
                  formatter: (val) => (val === 1 ? '实用新型' : val === 2 ? '发明专利' : '外观专利')
                }
              },
              {
                text: '业务负责人',
                align: 'center',
                divider: true,
                value: 'signUser',
                sortable: false,
                mobile: true,
                width: 140,
                formatter: (val, item) => {
                  let name = ''
                  if (item.contract) {
                    item.contract.contactsPersonList.forEach(i => {
                      name += `${i.name}|`
                    })
                  }
                  return (val ? val.name : name.substring(0, name.lastIndexOf("|"))) || '--'
                }
              },
              {
              text: '申请人名称',
              align: 'center',
              divider: true,
              value: 'applyUser',
              sortable: false,
              width: 200,
              copy: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              value: 'contract.serialNumber',
              sortable: false,
              copy: true,
              width: 200,
              formatter: (val) => val || '--'
            },
            {
              text: '费用负责人',
              align: 'center',
              value: 'operateUser.name',
              sortable: false,
              width: 130,
            },
            //   {
            //   text: '缴费截止',
            //   align: 'center',
            //   divider: true,
            //   value: 'acceptTime',
            //   sortable: false,
            //   width: 120,
            //   chip: {
            //     color: (val) => {
            //       const day = this.day(this.costDay(val))
            //       return day > 30 ? 'success' : (day <= 30 && day > 7) ? 'secondary' : 'error'
            //     },
            //     formatter: (val) => (this.day(this.costDay(val)) < 0 ? `超时(${Math.abs(this.day(this.costDay(val)))}天)` : `${this.day(this.costDay(val))}天后`)
            //   }
            // },
              {
                text: '操作',
                value: 'actions',
                align: 'center',
                sortable: false,
                class: 'fixed-right',
                cellClass: 'fixed-right',
                width: 140,
                mobile: true,
                actions: [
                {
                  text: '缴费',
                  color: 'green',
                  icon: 'mdi-pencil',
                  onClick: (row) => {
                    this.annualModal = { show: true, data: row }
                    this.form.annualFee = row.annualFee
                    this.form.patentId = row.id
                    this.form.remark = ''
                    this.form.year = this.item.params.costYear
                  },
                  disable: () => !this.$_has('patent-cost-edit')
                },
                // {
                //   text: '逾期',
                //   color: 'blue',
                //   icon: 'mdi-pencil',
                //   onClick: (row) => {
                //     this.overdueModal = { show: true, data: row }
                //   },
                //   disable: (row) => !this.$_has('patent-cost-edit') || this.costDay(row.acceptTime, 1) / 1000 > new Date().getTime() / 1000
                // }
              ]
            }
          ]
        },
        excel: {
          path: '/patent/info/nextCost/down',
          filename: '年费待缴名单.xls',
          header: '待缴费名单',
          fields: {
            客户名称: 'customerName',
            专利名称: 'name',
            专利类型: {
              field: 'patentType',
              callback: (val) => (val === 1 || val === 3 ? '实用新型/外观' : '发明')
            },
            业务负责人: 'busPersion',
            专利号: 'patentCode',
            受理时间: {
              field: 'acceptTime',
              callback: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            待缴金额: 'annualFee',
            缴费期限: {
              field: 'acceptTime',
              callback: (val) => this.$moment(this.costDay(val)).format('YYYY-MM-DD')
            }
          }
        }
      }
    },
    methods: {
      detail (item) {
        this.detailModal = { show: true, data: item }
      },
      cost () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
             if (res.status === 200) {
               this.annualModal.show = false
               this.loadData()
               this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
             }
             this.loading = false
          })
        }
      },
      onFileName (fileNames) {
        let costFileName = ''
        fileNames.forEach(name => {
          costFileName += `${this.bucket}/${name},`
        })
        this.form.costFileName = costFileName.substring(0, costFileName.lastIndexOf(','))
      },
      costColor (time) {
        const thisTime = new Date() // 当前时间
        const day = (thisTime - time) / 1000 / 60 / 60 / 24
        if (day >= 31) {
          return 'red'
        } else if (day >= 0 && day < 31) {
          return 'warning'
        } else if (day < 0 && day > -31) {
          return 'purple'
        }
        return 'black'
      },
      costDay (val) {
        const acceptTime = new Date(val * 1000)
        // const thisYearAcceptTime = new Date()
        acceptTime.setFullYear(this.item.params.costYear)
        // thisYearAcceptTime.setMonth(acceptTime.getMonth() + m) // 设置月份
        // thisYearAcceptTime.setDate(acceptTime.getDate())// 设置天
        // const day = (thisYearAcceptTime.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)// 剩余天数
        return acceptTime.getTime()
      },
      day (time) {
        const day = (getNextMonth(time, 1) - new Date().getTime()) / (1000 * 60 * 60 * 24)
        return Math.round(day)
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang="sass">
</style>
